import { render, staticRenderFns } from "./recoverChangePassword.vue?vue&type=template&id=7c8fffca&scoped=true&"
import script from "./recoverChangePassword.js?vue&type=script&lang=js&"
export * from "./recoverChangePassword.js?vue&type=script&lang=js&"
import style0 from "./recoverChangePassword.vue?vue&type=style&index=0&id=7c8fffca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8fffca",
  null
  
)

export default component.exports